export default __webpack_public_path__ + "static/media/Billie.308b9afc.png";